export function isAppPageRoute(route: string): boolean {
  return route.endsWith('/page')
}
